import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import cert1 from '../../assets/cert.png';
import cert2 from '../../assets/cert2.png';

export const Page9: React.FC = () => {
    const certifications = [
        {
            image: cert1,
            alt: 'Certification 1',
        },
        {
            image: cert2,
            alt: 'Certification 2',
        },
    ];

    return (
        <Container maxWidth={false} sx={{ paddingTop: '50px', paddingBottom: '50px' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'ClaireMurphy',
                        fontSize: {
                            xs: '30px',
                            sm: '40px',
                            md: '50px',
                        },
                        fontWeight: 400,
                        textAlign: 'center',
                        color: 'rgba(61, 61, 61, 1)',
                        marginBottom: {
                            xs: '20px',
                            md: '30px'
                        },
                    }}
                >
                    CERTIFICATION
                </Typography>

                {/* Stacked Layout - Top and Below */}
                <Grid container spacing={0} sx={{ width: '100%' }}>
                    {certifications.map((cert, index) => (
                        <Grid item xs={12} key={index}>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: {
                                        xs: '300px',
                                        sm: '350px',
                                        md: '400px',
                                        lg: '450px',
                                    },
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: index < certifications.length - 1 ? {
                                        xs: '20px',
                                        md: '30px'
                                    } : 0,
                                    '&:hover': {
                                        transform: 'scale(1.02)',
                                        transition: 'transform 0.3s ease',
                                    },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={cert.image}
                                    alt={cert.alt}
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
};
